import { render, staticRenderFns } from "./peopleLine.vue?vue&type=template&id=52eda00f&scoped=true"
import script from "./peopleLine.vue?vue&type=script&lang=js"
export * from "./peopleLine.vue?vue&type=script&lang=js"
import style0 from "./peopleLine.vue?vue&type=style&index=0&id=52eda00f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eda00f",
  null
  
)

export default component.exports